import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import React, { Fragment, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { loadError, receive, setPriceRequestResponse, } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { addToCartEvent } from '../Actions/Gtm.action';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
const BuyButton = function ({ label, articleNumber, quantityFieldId, isQuotationProduct, href, cssClass, buttonClassName, onClick, }) {
    return (_jsx(Fragment, { children: articleNumber ? (_jsx("a", { className: clsx(cssClass, buttonClassName), onClick: (e) => {
                e.preventDefault();
                onClick({
                    articleNumber,
                    quantityFieldId,
                    isQuotationProduct,
                });
            }, href: href || '#', rel: "nofollow", children: label })) : (_jsx("a", { className: cssClass, href: href || '#', rel: "nofollow", children: label })) }));
};
const StyledButton = (props) => {
    const dispatch = useDispatch();
    // Stable click handler to avoid recreating HOC component and triggering remounts.
    const onClick = useCallback(async ({ articleNumber, quantityFieldId, isQuotationProduct }) => {
        try {
            const quantityElement = quantityFieldId
                ? document.getElementById(quantityFieldId)
                : null;
            const quantity = quantityElement && quantityElement.value
                ? parseInt(quantityElement.value, 10)
                : 1;
            const response = await addToCartService({
                articleNumber,
                quantity,
                isQuotationProduct,
            });
            await addToCartEvent(articleNumber, quantity);
            dispatch(receive(response.cart));
            if (response.message !== null) {
                dispatch(setPriceRequestResponse(response.message, articleNumber));
            }
            try {
                const detail = {
                    articleNumber,
                    quantity,
                    name: response?.productName ||
                        props?.variantName ||
                        articleNumber,
                };
                window.dispatchEvent(new CustomEvent('cart:itemAdded', { detail }));
            }
            catch (e) {
                console.warn('[BuyButton] Failed dispatch cart:itemAdded', e);
            }
            return true;
        }
        catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    }, [dispatch, props?.variantName]);
    // Create HOC only once; recreating it every render causes unmount/mount and spinner reset.
    const ButtonRef = useRef();
    if (!ButtonRef.current) {
        ButtonRef.current = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
    }
    const Button = ButtonRef.current;
    const spinnerMinimumTime = props.spinnerMinimumTime || 1500;
    const successDisplayTime = props.successDisplayTime || 800;
    return (_jsx(Button, { ...props, spinnerMinimumTime: spinnerMinimumTime, successDisplayTime: successDisplayTime }));
};
export default StyledButton;
